// extracted by mini-css-extract-plugin
export var clickThrough = "_y7-2";
export var fallback = "_y7-5";
export var frame = "_y7-3";
export var frameCell = "_y7-1";
export var overlay = "_y7-4";
export var wrapper = "_y7-0";